export default __webpack_public_path__ + "static/media/icon-prev.a6ada167.svg";